const en = {
  activePlan: "Active Plan",
  endDate: "End Date",
  upgradePlan: "Upgrade Plan",
  logout: "Logout",
  expiryDate: "Expiry Date",
  add: "Add",
  vocabulary: "Vocabulary",
  vocabularyList: "Vocabulary List",
  listIsEmpty: "List is empty",
  addNewWord: "Add New Word",
  close: "Close",
  save: "Save",
  enterWordToSearch: "Enter word to search",
  wordAlreadyExists: "This word already exists.",
  filter: "Filter...",
  deleteWords: "Delete selected {{count}} words",
  deleteAllWords: "Delete all words",
  inputVocabularyWord: "Please enter the word to add...",
  deletedSuccessfully: "Deleted successfully",
  noMistakeFound: "No mistake found",
  noSuggestions: "No suggestions found",
  addToVocabulary: "Add to Vocabulary",
  spellCheck: "Spell Check",
  dictionary: "Dictionary",
  alwaysCheckSpelling: "Always check spelling",
  alwaysCheckSpellingDescription: "Automatically check for mistakes as you type.",
  refetchSpellcheck: "Refetch Spellcheck",
  search: "Search",
  copied: "Copied {{copied}}",
  searchResults: "Search Results",
  searchPlaceholder: "Please enter a word to search.",
  noInputToSearch: "Please enter a word to search",
  noSearchResults: "No search results found",
  loginSuccessful: "Login successful",
  loginFailed: "Login failed",
  loginText1: "Hello",
  loginText2: "there!",
  loginText3: "",
  loginWithTodu: "Login with Todu",
  noActiveSubscription: "You don't have an active subscription. Please upgrade your plan.",
  sessionExpired: "Session expired. Please log in again.",
};
export default en;
